import { useState } from 'react';
import { Button } from '../atoms/Button';
import { Icon } from '../atoms/Icon';
import { Input, type InputProps } from '../atoms/Input';

export interface PasswordInputProps extends Omit<InputProps, 'type' | 'endAdornment'> {
  /** Accessible label of the reveal button (i18n), e.g. "Passwort anzeigen". */
  showLabel: string;
}

/**
 * Password field with a button to show the password in plain text. The
 * button is a toggle (`aria-pressed`), so its label stays the same.
 */
export function PasswordInput({
  showLabel,
  autoComplete = 'current-password',
  ...rest
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <Input
      type={visible ? 'text' : 'password'}
      autoComplete={autoComplete}
      spellCheck={false}
      autoCapitalize="off"
      {...rest}
      endAdornment={
        <Button
          variant="ghost"
          size="sm"
          aria-label={showLabel}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
          iconStart={<Icon name={visible ? 'eye-off' : 'eye'} size="sm" />}
        />
      }
    />
  );
}
